<template>
  <!-- 转正 -->
  <div
    class="detail"
    v-if="data.action === 'U' ? is_show = true : is_show = false"
  >
    <ax-panel :noTitle="true">
      <van-cell
        title="姓名"
        :value="data.header.emplid_description"
      ></van-cell>
      <van-cell
        title="职位"
        :value="data.header.qh_external_posn"
      ></van-cell>
      <van-cell
        title="入职日期"
        :value="data.field_special_deal.hire_dt"
      ></van-cell>
      <van-cell
        title="部门"
        :value="data.header.deptid_description"
      ></van-cell>
      <van-cell
        title="直接上级"
        :value="data.field_special_deal.supervisor_name"
      ></van-cell>
      <van-cell
        title="层级"
        :value="data. header.qh_cj_code_description"
      ></van-cell>
    </ax-panel>
    <!-- 转正申请内容 -->
    <ax-panel title="转正申请内容">
      <van-cell title="工作目标及职责" />
      <van-cell>
        <p class="desc">{{data.header.qh_comments_001}}
        </p>
      </van-cell>
    </ax-panel>
    <ax-panel :noTitle="true">
      <van-cell title="六个月工作业绩回顾" />
      <van-cell>
        <p class="desc">{{data.header.qh_comments_002}}
        </p>
      </van-cell>
    </ax-panel>
    <ax-panel :noTitle="true">
      <van-cell title="对公司的意见和建议" />
      <van-cell>
        <p class="desc">{{data.header.qh_comments_003}}
        </p>
      </van-cell>
    </ax-panel>
    <!-- 部门评价 -->
    <ax-panel
      title="部门评价"
      v-show="data.field_special_deal.dept_evl_visible.dept_groupbox_visible||data.field_special_deal.qh_comments_005_visible||data.field_special_deal.action_dt_visible||data.field_special_deal.major_lvl_visible.xz_groupbox_visible"
    >
      <!-- 部门评价 -->
      <div v-show="data.field_special_deal.dept_evl_visible.dept_groupbox_visible">
        <!-- 工作业绩 -->
        <van-cell
          v-show="!data.field_special_deal.dept_evl_display.dept_groupbox_display"
          is-link
          :value="yjValue"
          @click="isyj=true"
        >
          <template #title>
            <span style="color:red">*&nbsp;</span>
            <span class="custom-title">工作业绩</span>
          </template>
        </van-cell>
        <van-popup
          v-model="isyj"
          position="bottom"
          :style="{ height: '30%' }"
        >
          <van-picker
            show-toolbar
            :columns="yjActions"
            @confirm="onYjSelect"
            @cancel="isyj=false"
          />
        </van-popup>
        <van-cell
          v-show="data.field_special_deal.dept_evl_display.dept_groupbox_display"
          title="工作业绩"
          :value="getDesc(data.qh_hr_002_apprv.qh_radio_01)"
        />
        <!-- 工作态度  -->
        <van-cell
          v-show="!data.field_special_deal.dept_evl_display.dept_groupbox_display"
          is-link
          :value="tdValue"
          @click="istd=true"
        >
          <template #title>
            <span style="color:red">*&nbsp;</span>
            <span class="custom-title">工作态度</span>
          </template>
        </van-cell>
        <van-popup
          v-model="istd"
          position="bottom"
          :style="{ height: '30%' }"
        >
          <van-picker
            show-toolbar
            :columns="tdActions"
            @confirm="onTdSelect"
            @cancel="istd=false"
          />
        </van-popup>
        <van-cell
          v-show="data.field_special_deal.dept_evl_display.dept_groupbox_display"
          title="工作态度"
          :value="getDesc(data.qh_hr_002_apprv.qh_radio_02)"
        />
        <!-- 工作技能 -->
        <van-cell
          v-show="!data.field_special_deal.dept_evl_display.dept_groupbox_display"
          is-link
          :value="jnValue"
          @click="isjn=true"
        >
          <template #title>
            <span style="color:red">*&nbsp;</span>
            <span class="custom-title">工作技能</span>
          </template>
        </van-cell>
        <van-popup
          v-model="isjn"
          position="bottom"
          :style="{ height: '30%' }"
        >
          <van-picker
            show-toolbar
            :columns="jnActions"
            @confirm="onJnSelect"
            @cancel="isjn=false"
          />
        </van-popup>
        <van-cell
          v-show="data.field_special_deal.dept_evl_display.dept_groupbox_display"
          title="工作技能"
          :value="getDesc(data.qh_hr_002_apprv.qh_radio_03)"
        />
        <!-- 工作描述 -->
        <van-cell v-show="!data.field_special_deal.dept_evl_display.dept_groupbox_display">
          <p class="title"><span style="color:red">*</span>工作描述(简述工作成果、工作态度、价值观等)</p>
        </van-cell>
        <van-cell v-show="!data.field_special_deal.dept_evl_display.dept_groupbox_display">
          <textarea
            class="comments_box"
            rows="5"
            v-model="becomeData.qh_comments_004"
            placeholder="请输入工作描述"
          ></textarea>
        </van-cell>
        <div v-show="data.field_special_deal.dept_evl_display.dept_groupbox_display&&data.qh_hr_002_apprv.qh_comments_004!=''">
          <van-cell>
            <p class="title">工作描述(简述工作成果、工作态度、价值观等)</p>
          </van-cell>
          <van-cell>
            <p class="desc">{{data.qh_hr_002_apprv.qh_comments_004}}</p>
          </van-cell>
        </div>

        <!-- 主要问题 -->
        <van-cell v-show="!data.field_special_deal.dept_evl_display.dept_groupbox_display">
          <p class="title"><span style="">*</span>主要问题（如上述三项中有评价为后两项的需要填写此项目）</p>
        </van-cell>
        <van-cell v-show="!data.field_special_deal.dept_evl_display.dept_groupbox_display">
          <textarea
            class="comments_box"
            rows="5"
            v-model="becomeData.comments"
            placeholder="请输入主要问题"
          ></textarea>
        </van-cell>

        <div v-show="data.field_special_deal.dept_evl_display.dept_groupbox_display&&data.qh_hr_002_apprv.comments!=''">
          <van-cell>
            <p class="title"><span>*</span>主要问题（如上述三项中有评价为后两项的需要填写此项目）
            </p>
          </van-cell>
          <van-cell>
            <p class="desc">{{data.qh_hr_002_apprv.comments}}
            </p>
          </van-cell>
        </div>
      </div>

      <!-- HR意见 -->
      <div v-show="data.field_special_deal.qh_comments_005_visible">
        <van-cell v-show="!data.field_special_deal.qh_comments_005_display">
          <!-- <p class="title"><span
              v-show="!data.field_special_deal.qh_comments_005_display"
              style="color:red"
            >*</span>HR意见(简述工作态度、价值观、岗位匹配度等)
          </p> -->
          <p class="title">HR意见(简述工作态度、价值观、岗位匹配度等)</p>
        </van-cell>
        <van-cell v-show="!data.field_special_deal.qh_comments_005_display">
          <textarea
            class="comments_box"
            rows="5"
            v-model="becomeData.qh_comments_005"
            placeholder="请输入HR意见"
          ></textarea>
        </van-cell>

        <div v-show="data.field_special_deal.qh_comments_005_display&&data.qh_hr_002_apprv.qh_comments_005!=''">
          <van-cell>
            <p class="title">HR意见(简述工作态度、价值观、岗位匹配度等)</p>
          </van-cell>
          <van-cell>
            <p class="desc">{{data.qh_hr_002_apprv.qh_comments_005}}
            </p>
          </van-cell>
        </div>
      </div>
      <!-- 转正生效日期 -->
      <div v-show="data.field_special_deal.action_dt_visible">
        <van-cell
          is-link
          :value="becomeDate"
          v-show="!data.field_special_deal.action_dt_display"
          @click="showBecomeDate=true"
        >
          <template #title>
            <span style="color:red">*&nbsp;</span>
            <span class="custom-title">转正生效日期</span>
            <!-- qh_hr_011_head.qh_work_trsfer_dt -->
          </template>
        </van-cell>
        <van-popup
          v-model="showBecomeDate"
          position="bottom"
          :style="{ height: '30%' }"
        >
          <van-datetime-picker
            type="date"
            v-model="minDate"
            @confirm="confirmBecomeDate"
            @cancel="showBecomeDate=false"
            :formatter="formatter"
          />
        </van-popup>
        <van-cell
          title="转正生效日期"
          v-show="data.field_special_deal.action_dt_display"
          :value="data.qh_hr_002_apprv.action_dt||data.field_special_deal.action_dt"
        />
      </div>

      <!-- 校招生 -->
      <!-- <div> -->
      <div v-show="data.field_special_deal.major_lvl_visible.xz_groupbox_visible">
        <van-collapse v-model="activeNames1">
          <van-collapse-item
            title='转正定级须知'
            name="remarks1"
            style="padding-right:0.3rem;color: #ccc;"
            value=""
          >
            <p style="color: #999999;margin:-10px 0 10px 0">校招生试用期转正时，HRBP将综合其在职表现（可综合考虑其学历、在职表现等），统合业务及相关部门的意见，更新定级情况</p>
            <p style="color: rgba(0, 0, 0, 0.65);line-height:20px">1.若该校招生表现符合预期，保持定级为S2</p>
            <p style="color: rgba(0, 0, 0, 0.65);line-height:20px"> 2.若该校招生表现超出预期，可提请相关流程更新定级为S3</p>
            <p style="color: rgba(0, 0, 0, 0.65);line-height:20px"> 3.若该校招生表现低于预期，需谨慎考虑是否转正或更新定级为S1</p>
            <p style="color: rgba(0, 0, 0, 0.65);line-height:20px"> 4.算法精英、安全星，按照培养方案规定，入职与普通学生定级一致，试用期结束后，表现优秀可直接调整为S4</p>
          </van-collapse-item>
        </van-collapse>
        <!-- 是否转正定级 -->
        <!-- 是否只读data.field_special_deal.major_lvl_display.xz_groupbox_display -->
        <van-cell
          v-show="!data.field_special_deal.major_lvl_display.xz_groupbox_display"
          is-link
          :value="djValue"
          @click="isdj=true"
        >
          <template #title>
            <span style="color:red">*&nbsp;</span>
            <span class="custom-title">是否转正定级</span>
          </template>
        </van-cell>
        <van-popup
          v-model="isdj"
          position="bottom"
          :style="{ height: '30%' }"
        >
          <van-picker
            show-toolbar
            :columns="djActions"
            @confirm="onDjSelect"
            @cancel="isdj=false"
          />
        </van-popup>
        <van-cell
          v-show="data.field_special_deal.major_lvl_display.xz_groupbox_display"
          title="是否转正定级"
          :value="yesOrNo(data.qh_hr_002_apprv.flag)"
        />
        <!-- 转正定级意见 -->
        <van-cell
          v-show="!data.field_special_deal.major_lvl_display.xz_groupbox_display&&ifComment"
          is-link
          :value="djyjValue"
          @click="isdjyj=true"
        >
          <template #title>
            <span style="color:red">*&nbsp;</span>
            <span class="custom-title">转正定级意见</span>
          </template>
        </van-cell>
        <van-popup
          v-model="isdjyj"
          position="bottom"
          :style="{ height: '30%' }"
        >
          <van-picker
            show-toolbar
            :columns="djyjActions"
            @confirm="onDjyjSelect"
            @cancel="isdjyj=false"
          />
        </van-popup>
        <van-cell
          v-show="data.field_special_deal.major_lvl_display.xz_groupbox_display&&data.qh_hr_002_apprv.flag==='Y'"
          title="转正定级意见"
          :value="data.qh_hr_002_apprv.qh_xz_major_lvl_description"
        />
      </div>

    </ax-panel>
  </div>
</template>

<script>
import moment from 'moment';
import request from '@/utils/request';
import watermark from '../../utils/warterMark';
export default {
  props: ['data', 'pageObj', 'comments'],
  data() {
    return {
      is_show: false,
      action: true,
      activeNames1: ['remarks1'],
      isyj: false,
      yjValue: '请选择',
      yjActions: [
        { text: '杰出', code: '1' },
        { text: '超过预期', code: '2' },
        { text: '符合预期', code: '3' },
        { text: '部分符合预期', code: '4' },
        { text: '不符合预期', code: '5' }
      ],
      istd: false,
      tdValue: '请选择',
      tdActions: [
        { text: '杰出', code: '1' },
        { text: '超过预期', code: '2' },
        { text: '符合预期', code: '3' },
        { text: '部分符合预期', code: '4' },
        { text: '不符合预期', code: '5' }
      ],
      isjn: false,
      jnValue: '请选择',
      jnActions: [
        { text: '杰出', code: '1' },
        { text: '超过预期', code: '2' },
        { text: '符合预期', code: '3' },
        { text: '部分符合预期', code: '4' },
        { text: '不符合预期', code: '5' }
      ],
      isdj: false,
      djValue: '请选择',
      djActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      isdjyj: false,
      djyjValue: '请选择',
      djyjActions: [
        { text: 'S1', code: '140' },
        { text: 'S2', code: '141' },
        { text: 'S3', code: '142' },
        { text: 'S4', code: '143' }
      ],
      ifComment: false, // 根据是否定级判断是否显示转正意见
      becomeDate: '请选择',
      showBecomeDate: false,
      minDate: new Date(),
      becomeData: {
        qh_radio_01: '',
        qh_radio_02: '',
        qh_radio_03: '',
        qh_comments_004: '',
        comments: '',
        qh_comments_005: '',
        action_dt: '',
        flag: '',
        qh_xz_major_lvl: ''
      }
    };
  },
  watch: {
    data() {
      console.log('this.data', this.data);
      // 水印
      this.$nextTick(() => {
        const name = this.data.current_user;
        const now = new Date();
        const date = `${now.getFullYear()}/${
          now.getMonth() + 1
        }/${now.getDate()} ${now.getHours()}:${
          now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
        }`;
        watermark.set(date + name);
      });
      if (this.data.action === 'V') {
        this.$dialog
          .alert({
            message: '已完成的审批暂时无法查询请知悉'
          })
          .then(() => {
            console.log('转正已审批');
          });
      }
      // 工作业绩、工作态度、工作技能、工作描述、主要问题  只读回传返回值
      if (this.data.field_special_deal.dept_evl_display.dept_groupbox_display) {
        this.becomeData.qh_radio_01 = this.data.qh_hr_002_apprv.qh_radio_01;
        this.becomeData.qh_radio_02 = this.data.qh_hr_002_apprv.qh_radio_02;
        this.becomeData.qh_radio_03 = this.data.qh_hr_002_apprv.qh_radio_03;
        this.becomeData.qh_comments_004 = this.data.qh_hr_002_apprv.qh_comments_004;
        this.becomeData.comments = this.data.qh_hr_002_apprv.comments;
      }
      // HR意见  只读回传返回值
      if (this.data.field_special_deal.qh_comments_005_display) {
        this.becomeData.qh_comments_005 = this.data.qh_hr_002_apprv.qh_comments_005;
      }
      // 转正定级意见  只读回传返回值
      if (this.data.field_special_deal.major_lvl_display.xz_groupbox_display) {
        this.becomeData.flag = this.data.qh_hr_002_apprv.flag;
        this.becomeData.qh_xz_major_lvl = this.data.qh_hr_002_apprv.qh_xz_major_lvl;
      }
      // 转正生效日期
      // 是否可见data.field_special_deal.action_dt_visible
      // 是否只读data.field_special_deal.action_dt_display
      // data.qh_hr_002_apprv.action_dt||data.field_special_deal.action_dt
      const date =
        this.data.qh_hr_002_apprv.action_dt ||
        this.data.field_special_deal.action_dt;
      this.becomeData.action_dt = date;
      this.becomeDate = date === '' ? '请选择' : date;
      this.getSelect();
    }
  },

  methods: {
    // 父组件通过ref获取子组件的becomeData
    returnBecomeData(item) {
      // becomeData: {
      //   qh_radio_01: '',
      //   qh_radio_02: '',
      //   qh_radio_03: '',
      //   qh_comments_004: '',
      //   qh_comments_005: '',
      //   flag: '',
      //   qh_xz_major_lvl: ''
      // }
      let bData = {},
        verifyArr = [],
        outFlag = false;
      // 部门评价可见
      if (
        this.data.field_special_deal.dept_evl_visible.dept_groupbox_visible &&
        !this.data.field_special_deal.dept_evl_display.dept_groupbox_display
      ) {
        verifyArr = verifyArr.concat([
          'qh_radio_01',
          'qh_radio_02',
          'qh_radio_03',
          'qh_comments_004'
        ]);
        bData.qh_radio_01 = this.becomeData.qh_radio_01;
        bData.qh_radio_02 = this.becomeData.qh_radio_02;
        bData.qh_radio_03 = this.becomeData.qh_radio_03;
        bData.qh_comments_004 = this.becomeData.qh_comments_004;
      }
      // HR意见可见不必填
      // if (
      //   this.data.field_special_deal.qh_comments_005_visible &&
      //   !this.data.field_special_deal.qh_comments_005_display
      // ) {
      //   verifyArr.push('qh_comments_005');
      //   bData.qh_comments_005 = this.becomeData.qh_comments_005;
      // }
      // 转正日期
      if (
        this.data.field_special_deal.action_dt_visible &&
        !this.data.field_special_deal.action_dt_display
      ) {
        verifyArr.push('action_dt');
        bData.action_dt = this.becomeData.action_dt;
      }
      // 主要问题
      if (
        this.becomeData.qh_radio_01 > 3 ||
        this.becomeData.qh_radio_02 > 3 ||
        this.becomeData.qh_radio_03 > 3
      ) {
        verifyArr.push('comments');
        bData.comments = this.becomeData.comments;
      }
      // 转正定级可见
      if (
        this.data.field_special_deal.major_lvl_visible.xz_groupbox_visible &&
        !this.data.field_special_deal.major_lvl_display.xz_groupbox_display
      ) {
        bData.flag = this.becomeData.flag;
        verifyArr.push('flag');
        if (this.ifComment === true) {
          verifyArr.push('qh_xz_major_lvl');
          bData.qh_xz_major_lvl = this.becomeData.qh_xz_major_lvl;
        } else {
          this.becomeData.qh_xz_major_lvl = '';
        }
      }
      const empty = this.getEmpty(this.becomeData, verifyArr);
      // 有未填写的信息
      if (empty && item === 1) {
        outFlag = false;
        this.toast && this.toast.clear();
        this.toast = this.$toast({
          message: this.getEmptyMessage(empty),
          duration: 1500
        });
      } else {
        outFlag = true;
      }
      this.$emit('getBcomeData', this.becomeData, outFlag);
    },
    // 必填校验
    getEmpty(obj, arr) {
      for (let key in obj) {
        if (!obj[key] && arr.includes(key)) {
          return key;
        }
      }
      return '';
    },
    // 校验返回信息
    getEmptyMessage(key) {
      switch (key) {
        case 'qh_radio_01':
          return '请选择工作业绩';
          break;
        case 'qh_radio_02':
          return '请选择工作态度';
          break;
        case 'qh_radio_03':
          return '请选择工作技能';
          break;
        case 'qh_comments_004':
          return '请填写工作描述';
          break;
        case 'comments':
          return '请填写主要问题';
          break;
        case 'qh_comments_005':
          return '请填写HR意见';
          break;
        case 'action_dt':
          return '请选择转正日期';
          break;
        case 'flag':
          return '请选择是否转正定级';
          break;
        case 'qh_xz_major_lvl':
          return '请选择转正定级意见';
          break;
      }
    },
    // 评价信息
    getDesc(key) {
      switch (key) {
        case '1':
          return '杰出';
          break;
        case '2':
          return '超过预期';
          break;
        case '3':
          return '符合预期';
          break;
        case '4':
          return '部分符合预期';
          break;
        case '5':
          return '不符合预期';
          break;
      }
    },
    // 只读过滤是否的过滤器
    yesOrNo(str) {
      return str ? (str === 'Y' ? '是' : '否') : '';
    },
    // 工作业绩
    onYjSelect(item) {
      this.isyj = false;
      this.yjValue = item.text;
      this.becomeData.qh_radio_01 = item.code;
    },
    // 工作态度
    onTdSelect(item) {
      this.istd = false;
      this.tdValue = item.text;
      this.becomeData.qh_radio_02 = item.code;
    },
    // 工作技能
    onJnSelect(item) {
      this.isjn = false;
      this.jnValue = item.text;
      this.becomeData.qh_radio_03 = item.code;
    },
    // 是否转正定级
    onDjSelect(item) {
      item.code === 'Y' ? (this.ifComment = true) : (this.ifComment = false);
      this.isdj = false;
      this.djValue = item.text;
      this.becomeData.flag = item.code;
    },
    // 是否转正定级
    onDjyjSelect(item) {
      this.isdjyj = false;
      this.djyjValue = item.text;
      this.becomeData.qh_xz_major_lvl = item.code;
    },
    formatDate(date) {
      return moment(date).format('YYYY/MM/DD');
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },
    // 承接转发开始日期
    confirmBecomeDate(date) {
      this.showBecomeDate = false;
      this.becomeDate = this.formatDate(date);
      this.becomeData.action_dt = this.becomeDate;
    },
    // 获取转正定级意见
    getSelect() {
      const options = {
        url: '/treasure/ehr/becomeRegular/DoMajorLvlAction',
        method: 'post'
      };
      let body = {
        emplid: this.data.header.emplid
      };
      if (this.pageObj.data) {
        this.pageObj.data.forEach((item) => {
          body[item[0]] = this[item[1]];
        });
      }
      if (this.pageObj.method === 'get') {
        options.params = body;
      } else {
        options.data = body;
      }
      request(options)
        .then(({ data }) => {
          this.$toast.clear();
          if (data.code === 200) {
            let arr = [];
            data.data.forEach((item) => {
              arr.push({
                text: item.qh_xz_major_lvl_description,
                code: item.qh_xz_major_lvl
              });
            });
            this.djyjActions = arr;
          } else {
            this.$toast.fail({
              message: data.message,
              duration: 1500
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.6rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.base {
  border-bottom: none;
}
.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}
.van-cell .van-cell__title {
  width: 4rem;
  // color:#000
}
.w100 .van-cell__title {
  width: 8rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}
.desc {
  color: #ccc;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
}
.remark {
  .van-collapse-item__content {
    color: rgba(0, 0, 0, 0.9);
  }
}
// 审批意见框
.comments_box {
  box-sizing: border-box;
  width: 100%;
  outline: none;
  font-size: 14px;
  border: none;
  padding: 8px 16px;
  &::-webkit-input-placeholder {
    color: #c7c7c7;
  }
}
</style>